export const pizzaPricesCombinadas = [
  {
    key: "Hawaiiana",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 22990,
      grande: 27990,
    },
    text: "Hawaiiana",
    description: "Pizza de Jamon y piña, una excelente combinacion",
    pizzaImg:require('../img/imgMenuPizzas/pizzaHawaiiana.jpeg'),
  },
  {
    key: "Salami pimentón",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 22990,
      grande: 27990,
    },
    text: "Salami pimentón",
    description: "Pizza de salami con pimentón",
    pizzaImg: require("../img/imgMenuPizzas/pizzaSalamiPimenton.jpeg"),
  },
  {
    key: "Salchiloca",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 22990,
      grande: 27990,
    },
    text: "Salchiloca",
    description: "Salchicha ranchera caramelizada con coca-cola",
    pizzaImg: require("../img/imgMenuPizzas/salchiloca.jpeg"),
  },
  {
    key: "Pollo champiñón",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 24990,
      grande: 29990,
    },
    text: "Pollo champiñón",
    description: "Pizza con champiñónes y pollo",
    pizzaImg:require('../img/imgMenuPizzas/pizzaPolloChampinones.jpg'),
  },
  {
    key: "Pollo Maiz",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 24990,
      grande: 29990,
    },
    text: "Pollo Maiz",
    description: "Pizza con pollo y maiz",
    pizzaImg:require('../img/imgMenuPizzas/pizzaPolloMaiz.png'),
  },
  {
    key: "Pollo Jamón",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 24990,
      grande: 29990,
    },
    text: "Pollo Jamón",
    description: "Pizza de pollo con jamón, super deliciosa",
    pizzaImg:require('../img/imgMenuPizzas/pizzaPolloJamon.jpg'),
  },
  {
    key: "Pollo cebolla caramelizada",
    value: {
      personal: 8000,
      pequeña: 14990,
      mediana: 24990,
      grande: 29990,
    },
    text: "Pollo cebolla caramelizada",
    description: "Pizza de Pollo y cebolla caramelizada",
    pizzaImg:require('../img/imgMenuPizzas/pizzaPolloCebollak.jpeg'),
  },
  
  {
    key: "Panitas",
    value: {
      personal: 10000,
      pequeña: 18990,
      mediana: 27990,
      grande: 34990,
    },
    text: "Panitas",
    description: "Maiz, pollo, tocineta y una pizca de albahaca",
    pizzaImg: require("../img/imgMenuPizzas/panitas.jpeg"),
  },
  
];
